module.exports = __webpack_public_path__ + "img/emotion-design@2x.00a6dd0.webp";